import { render, staticRenderFns } from "./TaskDetails.vue?vue&type=template&id=37a99b14&scoped=true&"
import script from "./TaskDetails.vue?vue&type=script&lang=js&"
export * from "./TaskDetails.vue?vue&type=script&lang=js&"
import style0 from "./TaskDetails.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TaskDetails.vue?vue&type=style&index=1&id=37a99b14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a99b14",
  null
  
)

export default component.exports